import { render, staticRenderFns } from "./THead.vue?vue&type=template&id=04463416&"
import script from "./THead.vue?vue&type=script&lang=js&"
export * from "./THead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports